import React, { useMemo } from 'react';
import { latinAlphabet, url} from '../../../utils/variables';
import ImagePickerModal from '../../master/ImagePickerModal';
import { useTranslation } from 'react-i18next';

export default function UploadDocs({attachments, insuranceType, uploadDoc, changeStep, losses, hasCoroukie}) {
    const { t } = useTranslation();
    const label = useMemo(() => insuranceType === 'third' ? t('Culprit') : '', [insuranceType]);

    function renderButton(name, title) {
        const image = attachments.find(itm => itm.filename === name);
        return (
            <div className='upload-parent'>
                <div className='upload-text'>{title}</div>
                {
                    image ?
                        <img src={`${url}/files?uid=${image.uid}&width=68&height=40`} alt='img'/> :

                        <div className='upload-icon-parent'>
                            <i className='fas fa-image'/>
                        </div>
                }
            </div>
        )
    }

    return (
        
        <div className='complete-content'>
            <div className='box-wrapper'>
                <div className='title'>{t('Culprit docs')}</div>
                <div className='px20 py10'>
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_license_image', `${t('License')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_license_image', done)}
                        label='license_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_license_image')}
                    />
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_license_back_image', `${t('License back')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_license_back_image', done)}
                        label='back_license_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_license_back_image')}
                    />
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_vehicle_card_image', `${t('Car card')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_vehicle_card_image', done)}
                        label='vehicle_card_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_vehicle_card_image')}
                    />
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_vehicle_card_back_image', `${t('Car back card')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_vehicle_card_back_image', done)}
                        label='vehicle_card_back_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_vehicle_card_back_image')}
                    />
                    <ImagePickerModal
                        renderBtn={renderButton('culprit_third_image', `${t('Third insurance')} ${label}`)}
                        upload={(image, done) => uploadDoc(image, 'culprit_third_image', done)}
                        label='third_image'
                        imageUid={attachments.find(itm => itm.filename === 'culprit_third_image')}
                    />
                    {
                        insuranceType === 'body' &&
                        <ImagePickerModal
                            renderBtn={renderButton('culprit_body_image', t('Body insurance'))}
                            upload={(image, done) => uploadDoc(image, 'culprit_body_image', done)}
                            label='third_image'
                            imageUid={attachments.find(itm => itm.filename === 'culprit_body_image')}
                        />
                    }
                </div>
            </div>
            {
                insuranceType === 'third' &&
                    losses.map((itm, index) => (
                        <div className='box-wrapper' key={index}>
                            <div className='title'>{`${t('Losses docs')} ${t(latinAlphabet[index])}`}</div>
                            <div className='px20 py10'>
                                <ImagePickerModal
                                    renderBtn={renderButton(`losses_license_image${index + 1}`, `${t('License')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_license_image${index + 1}`, done)}
                                    label='license_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_license_image${index + 1}`)}
                                />
                                <ImagePickerModal
                                    renderBtn={renderButton(`losses_license_back_image${index + 1}`, ` ${t('License back')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_license_back_image${index + 1}`, done)}
                                    label='back_license_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_license_back_image${index + 1}`)}
                                />
                                <ImagePickerModal
                                    renderBtn={renderButton(`losses_vehicle_card_image${index + 1}`, `${t('Car card')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_vehicle_card_image${index + 1}`, done)}
                                    label='vehicle_card_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_vehicle_card_image${index + 1}`)}
                                />
                                <ImagePickerModal
                                    renderBtn={renderButton(`losses_vehicle_card_back_image${index + 1}`, `${t('Car back card')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_vehicle_card_back_image${index + 1}`, done)}
                                    label='vehicle_card_back_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_vehicle_card_back_image${index + 1}`)}
                                />
                                <ImagePickerModal
                                    renderBtn={renderButton(`losses_third_image${index + 1}`, `${t('Third insurance')} ${t('Losses')} ${t(latinAlphabet[index])}`)}
                                    upload={(image, done) => uploadDoc(image, `losses_third_image${index + 1}`, done)}
                                    label='third_image'
                                    imageUid={attachments.find(itm => itm.filename === `losses_third_image${index + 1}`)}
                                />
                            </div>
                        </div>
                    ))
            }
            <div className='nav-button-parent'>
                <button className='navButton mr5' onClick={() => changeStep(2)}>
                    {t('Next step')}
                    <i className='fas fa-chevron-down'/>
                </button>
                {!!hasCoroukie &&
                    <button
                        className='navButton prev ml5'
                        onClick={() => changeStep(0)}
                    >
                       {t('Prev step')}
                        <i className='fas fa-chevron-up'/>
                    </button>
                }
            </div>
        </div>
    );

}
